import { z } from 'zod/v4';
import { ILink, LINK_SCHEMA } from './link.interfaces';
import { INormalText, NORMAL_TEXT_SCHEMA } from './text/text.interfaces';
import { Brand } from '../branded-types';
import { EFooterBlockType } from './footer-block-type.enums';
import { ACCESSIBLE_IMAGE_SCHEMA, IAccessibleImage } from './image.interfaces';

export type LinkAreaId = Brand<string, 'linkAreaId'>;

export const LINK_AREA_SCHEMA: z.ZodType<ILinkArea> = z.object({
  id: z
    .uuid()
    .transform((s: string) => s as LinkAreaId)
    .optional(),
  isActive: z.boolean().optional(),
  headlines: z.array(NORMAL_TEXT_SCHEMA),
  texts: z.array(NORMAL_TEXT_SCHEMA).optional(),
  links: z.array(LINK_SCHEMA),
  accessibleImages: z.array(ACCESSIBLE_IMAGE_SCHEMA).optional(),
  type: z.enum(EFooterBlockType).optional(),
});

export interface ILinkArea {
  id?: LinkAreaId;
  isActive?: boolean;
  headlines: INormalText[];
  texts?: INormalText[];
  links: ILink[];
  accessibleImages?: IAccessibleImage[];
  type?: EFooterBlockType | string;
}
